/**
 * Catálogo: Tipo de estructura. Const portable, framework-agnostic.
 */
export const StructureType = {
  TOWER: 'T',
  VILLA: 'V'
} as const

export type StructureType = (typeof StructureType)[keyof typeof StructureType]

export const StructureTypeLabel = {
  [StructureType.TOWER]: 'Torre',
  [StructureType.VILLA]: 'Villa'
} as const satisfies Record<StructureType, string>

export const StructureTypeOptions = Object.values(StructureType).map((value) => ({
  value: StructureTypeLabel[value],
  label: StructureTypeLabel[value]
}))
